import { actionTypes } from "../_actions/exchange.action";
import { IChartTrade, IExchange } from "../../interfaces";
import moment from "moment";
import { OrderExecutionType } from "../../_utils/types";

const initialState: IExchange = {
  // Users Info
  userOrders: {
    open: [],
    close: []
  },
  userTransactions: {
    deposit: [],
    withdraw: [],
    transfer: []
  },
  pendingTxnsCount: 0,
  exchangeAssets: [],
  dollarPrices: {},
  depositBalance: {
    base_available_balance: "0",
    price_available_balance: "0",
    base_locked_balance: "0",
    price_locked_balance: "0",
  },

  // Orderbook
  lastUpdateId: 0,
  buyOrders: [],
  sellOrders: [],
  buyOrdersTolalCount: 0,
  sellOrdersTolalCount: 0,
  flashOrders: [],
  orderBook: {
    currentLtp: "0",
    lastLtp: "0",
  },

  // User Orders
  buySellTab: "B",
  limitMarketTab: "L",
  openHistoryTab: OrderExecutionType.open,
  orderPrice: "",
  orderAmount: "",
  orderTotal: "",

  // Market Trades
  marketTrades: [],

  // Market Pair
  listOfPairs: [],
  mftCached: false,

  // Charts
  chartTrade: {} as IChartTrade,
};

const exchange = (state = initialState, action): IExchange => {
  switch (action.type) {
    // ============== For User Data ==============
    case actionTypes.SAVE_USER_ORDERS:
      return {
        ...state,
        userOrders: { ...action.data },
      };
    case actionTypes.SAVE_DEPOSIT_BALANCE:
      return {
        ...state,
        depositBalance: { ...action.data },
      };
    case actionTypes.SAVE_USER_WALLET_TRANSACTIONS:
      return {
        ...state,
        userTransactions: { 
          ...state.userTransactions,
          [action.data.key]: [...action.data.value]
        },
      };
    case actionTypes.SAVE_PENDING_TRANSACTIONS_COUNT:
      return {
        ...state,
        pendingTxnsCount: action.data,
      };
    case actionTypes.SAVE_USER_EXCHANGE_ASSETS:
      return {
        ...state,
        exchangeAssets: [...action.data],
      };
    case actionTypes.SAVE_DOLLAR_PRICES:
      return {
        ...state,
        dollarPrices: {
          ...state.dollarPrices, 
          ...action.data
        },
      };
  
    // ================ Order Book ============================
    case actionTypes.UPDATE_ORDER_BOOK:
      return {
        ...state,
        lastUpdateId: action.data.lastUpdateId,
        buyOrders: [...action.data.buy],
        sellOrders: [...action.data.sell],
      };
    case actionTypes.BUY_ORDERS_TOTAL_COUNT:
      return {
        ...state,
        buyOrdersTolalCount: action.data,
      };
    case actionTypes.SELL_ORDERS_TOTAL_COUNT:
      return {
        ...state,
        sellOrdersTolalCount: action.data,
      };
    case actionTypes.SAVE_FLASH_ORDERS:
      return {
        ...state,
        flashOrders: [...action.data],
      };
    case actionTypes.SAVE_LTP:
      return {
        ...state,
        orderBook: action.data,
      };

    // ================ User Orders ============================
    case actionTypes.SAVE_ORDER_PRICE:
      return {
        ...state,
        orderPrice: action.data,
      };
    case actionTypes.SAVE_ORDER_AMOUNT:
      return {
        ...state,
        orderAmount: action.data,
      };
    case actionTypes.SAVE_ORDER_TOTAL:
      return {
        ...state,
        orderTotal: action.data,
      };
    case actionTypes.SAVE_BUY_SELL_TAB:
      return {
        ...state,
        buySellTab: action.data,
      };
    case actionTypes.SAVE_LIMIT_MARKET_TAB:
      return {
        ...state,
        limitMarketTab: action.data,
      };
    case actionTypes.SAVE_OPEN_HISTORY_TAB:
      return {
        ...state,
        openHistoryTab: action.data,
      };

    // ================ Market Trades ============================
    case actionTypes.SAVE_MARKET_TRADES:
      return {
        ...state,
        marketTrades: [...action.data],
      };

    // ================ Market Pairs ============================
    case actionTypes.SAVE_LIST_OF_PAIRS:
      return {
        ...state,
        listOfPairs: [...action.data],
      };
    case actionTypes.SAVE_MFT:
      return {
        ...state,
        mftCached: action.data,
      };

    // ================ Charts ================
    case actionTypes.SAVE_CHART_TRADE:
      const chartTrade = {
        price: action.data[0],
        volume: action.data[1],
        time: moment(action.data[3]).unix(),
      };
      return {
        ...state,
        chartTrade,
      }

    // ================ Reset on pair Change ============================
    case actionTypes.SAVE_INITIAL_STATE:
      return {
        ...state,

        orderPrice: "",
        depositBalance: {
          base_available_balance: "0",
          price_available_balance: "0",
          base_locked_balance: "0",
          price_locked_balance: "0",
        },
        lastUpdateId: 0,
        buyOrders: [],
        sellOrders: [],
        orderBook: {
          currentLtp: "0",
          lastLtp: "0",
        },
        marketTrades: [],
      };

    // ================ Reset on Account Change ============================
    case actionTypes.SAVE_INITIAL_WALLET_STATE:
      return {
        ...state,
        depositBalance: {
          base_available_balance: "0",
          price_available_balance: "0",
          base_locked_balance: "0",
          price_locked_balance: "0",
        },
        userOrders: {
          open: [],
          close: []
        },
        userTransactions: {
          deposit: [],
          withdraw: [],
          transfer: []
        },
        pendingTxnsCount: 0
      };
    default:
      return state;
  }
};

export default exchange;
